
/**
 * Created by nijin on 31/1/17.
 */
import {Routes, RouterModule} from "@angular/router";
import {NgModule} from "@angular/core";
import {SchemaComponent} from "./schema.component";
import {ChooseSchemaComponent} from "./edit-schema/choose-schema.component";
import {CustomSchemaComponent} from "./schema-list/custom-schema.component";
import {PredefinedSchemaComponent} from "./schema-list/predefined-schema.component";
import {SchemaTileComponent} from "./schema-list/schema-tile.component";
import {SchemaListComponent} from "./schema-list/schema-list.component";
import {CreateSchemaComponent} from "./create/create.component";
import {EditAttributeComponent} from "./edit-schema/edit-attribute.component";
import {EditLocationComponent} from "./edit-schema/edit-location.component";
import {LocAttrForm} from "./edit-schema/loc-attribute-form.component";
import {CommonHeaderComponent} from "./shared/common-header";
import {SchemaUpdateWarning} from "./shared/modal/warning.modal";
import {SaveSchemaModal} from "./shared/modal/save.schema.modal";
import {LocationTypeChangeWarning} from "./shared/modal/location.type.change.confirmation";
import {GLOBAL_CONSTANTS} from "../global/global.constants";
const routes: Routes = [
  {
    path:'',
    component:SchemaComponent,
    children:[
      {
        path: '',
        component:SchemaListComponent,
        children:[
          {
            path: 'templates',
            component: PredefinedSchemaComponent,
            data: {
              title: GLOBAL_CONSTANTS.PAGE_TITLE.TEMPLATE
            }
          },
          {
            path: '',
            component: CustomSchemaComponent,
            data: {
              title: GLOBAL_CONSTANTS.PAGE_TITLE.SCHEMA
            }
          },
        ]
      },
      {
        path: 'new',
        component: CreateSchemaComponent,
        data: {
          title: GLOBAL_CONSTANTS.PAGE_TITLE.CREATE_SCHEMA
        }
      }

    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: [],
})
export class SchemaRoutingModule { }

export let ROUTED_COMPONENTS = [
  SchemaComponent,
  CommonHeaderComponent,
  ChooseSchemaComponent,
  CustomSchemaComponent,
  PredefinedSchemaComponent,
  SchemaTileComponent,
  SchemaListComponent,
  CreateSchemaComponent,
  EditAttributeComponent,
  EditLocationComponent,
  LocAttrForm,
  SchemaUpdateWarning,
  SaveSchemaModal,
  LocationTypeChangeWarning
];



// WEBPACK FOOTER //
// ./src/app/schema/schema.routing.module.ts